import { detranClient } from '@lib/detranClient';

/** Campo do cadastro do condutor que a Gestão DETRAN pode alterar. */
export interface CampoEditavel {
  field: string;
  label: string;
  type: 'string' | 'number' | 'boolean';
}

export type DadosCondutor = Record<string, string | number | boolean>;

export interface CondutorResponse {
  dados: DadosCondutor;
  camposEditaveis: CampoEditavel[];
}

export interface AlteracaoCondutorResponse {
  previous: DadosCondutor;
  current: DadosCondutor;
  changedFields: string[];
}

export async function getCondutor(cpf: string): Promise<CondutorResponse> {
  const response = await detranClient.get<CondutorResponse>(`/detran/gestao/cidadao/${cpf}`);

  return response.data;
}

export async function patchCondutor(cpf: string, changes: DadosCondutor): Promise<AlteracaoCondutorResponse> {
  const response = await detranClient.patch<AlteracaoCondutorResponse>(`/detran/gestao/cidadao/${cpf}`, changes);

  return response.data;
}

export async function resetCondutor(cpf: string): Promise<CondutorResponse> {
  const response = await detranClient.post<{ reset: boolean; dados: DadosCondutor }>(
    `/detran/gestao/cidadao/${cpf}/reset`,
  );

  return { dados: response.data.dados, camposEditaveis: [] };
}
